import { render } from "./DownloadIcon.vue?vue&type=template&id=2cc7ea93"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DownloadIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cc7ea93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cc7ea93', __exports__)) {
    api.reload('2cc7ea93', __exports__)
  }
  
  module.hot.accept("./DownloadIcon.vue?vue&type=template&id=2cc7ea93", () => {
    api.rerender('2cc7ea93', render)
  })

}


export default __exports__